import React from 'react';
import { Container } from '@mui/material';
import CodingProblemsManager from './components/CodingProblemsManager';

export default function CodingProblemsPage() {
  return (
    <Container maxWidth="lg" sx={{ py: 3 }}>
      <CodingProblemsManager />
    </Container>
  );
}
